import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-lead-list',
  templateUrl: './lead-list.component.html',
  styleUrls: ['./lead-list.component.css']
})
export class LeadListComponent implements AfterViewInit {
  users = [
    {
      name: 'John Doe',
      status: 'active',
      accountName: 'Acme Corp',
      officeNumber: '1234567890',
      email: 'john.doe@acmecorp.com'
    },
    {
      name: 'Jane Smith',
      status: 'inactive',
      accountName: 'Global Tech',
      officeNumber: '9876543210',
      email: 'jane.smith@globaltech.com'
    },
    {
      name: 'Mark Johnson',
      status: 'active',
      accountName: 'Bluewave Ltd',
      officeNumber: '4567891230',
      email: 'mark.johnson@bluewave.com'
    },
    {
      name: 'Emily Davis',
      status: 'inactive',
      accountName: 'Future Innovations',
      officeNumber: '7891234560',
      email: 'emily.davis@futureinno.com'
    },
    {
      name: 'Robert Brown',
      status: 'active',
      accountName: 'NextGen Solutions',
      officeNumber: '3216549870',
      email: 'robert.brown@nextgen.com'
    }
  ];
  displayedColumns: string[] = ['sno', 'name', 'status', 'accountName', 'officeNumber', 'email'];
  dataSource = new MatTableDataSource(this.users);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  // onStatusChange(event: any) {
  //   console.log(event)
  //   const status = event.value;
  //   this.dataSource.data = status
  //     ? this.users.filter(user => user.status === status)
  //     : this.users;
  // }

  onStatusChange(event: any) {
    const status = (event.target as HTMLSelectElement).value;
    this.dataSource.data = status
      ? this.users.filter(user => user.status === status)
      : this.users;
}
}